import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, NavigationEnd, RouterOutlet, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent } from './footer';
import { HeaderComponent } from './header';
import { SidebarComponent } from './sidebar';
import { ThemeCustomizerComponent } from './theme-customizer';
import { NgClass, NgIf } from '@angular/common';
import { AppService } from '../services/app.service';
import { FirebaseNotificationInitService } from '../services/firebase/firebase-notification-init.service';
import { BuilderWorkspacePickerModalComponent } from '../shared/components/builder-workspace-picker-modal/builder-workspace-picker-modal.component';

@Component({
  selector: 'app-root',
  templateUrl: './app-layout.html',
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    ThemeCustomizerComponent,
    SidebarComponent,
    HeaderComponent,
    RouterOutlet,
    FooterComponent,
    BuilderWorkspacePickerModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppLayout implements OnInit {
  store: any;
  showTopButton = false;
  currentModule = '';
  headerClass = '';
  private readonly firebaseNotificationInit = inject(
    FirebaseNotificationInitService,
  );

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    private service: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.initStore();
    this.currentModule = this.activatedRoute.snapshot?.url[0]?.path || '';
  }

  ngOnInit() {
    this.initAnimation();
    this.toggleLoader();
    // Post-auth FCM setup — must not block layout; failures are swallowed.
    void this.firebaseNotificationInit.initialize();
    window.addEventListener('scroll', () => {
      if (
        document.body.scrollTop > 50 ||
        document.documentElement.scrollTop > 50
      ) {
        this.showTopButton = true;
      } else {
        this.showTopButton = false;
      }
    });
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', () => {});
  }

  initAnimation() {
    this.service.changeAnimation();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.service.changeAnimation();
      }
    });

    const ele: any = document.querySelector('.animation');
    ele.addEventListener('animationend', () => {
      this.service.changeAnimation('remove');
    });
  }

  toggleLoader() {
    this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
    setTimeout(() => {
      this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
    }, 500);
  }

  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  goToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
